import {
  Check,
  Moon,
  LucideProps,
  SunMedium,
  User,
  ArrowRight,
  Clock,
  MoveLeft,
  ChevronLeft,
  Eye,
  EyeOff,
  Share2,
  Bookmark,
  AlertCircle,
  UserCircle,
  Play,
  Settings,
  LogOut,
  Code,
  TrendingUp,
  Upload,
  UploadCloud,
  CheckCircle,
  Banknote,
  Edit
} from 'lucide-react'
interface IconProps extends Omit<LucideProps, 'ref'> {
  fill: string
}

export const Icons = {
  sun: SunMedium,
  moon: Moon,
  user: User,
  userCircle: UserCircle,
  check: Check,
  arrowRight: ArrowRight,
  clock: Clock,
  moveLeft: MoveLeft,
  chevronLeft: ChevronLeft,
  eye: Eye,
  eyeOff: EyeOff,
  share: Share2,
  bookmark: Bookmark,
  report: AlertCircle,
  play: Play,
  settings: Settings,
  logOut: LogOut,
  code: Code,
  trendingUp: TrendingUp,
  upload: Upload,
  uploadCloud: UploadCloud,
  CheckCircle: CheckCircle,
  Banknote: Banknote,
  Edit: Edit,
  thumbsUp: ({ fill, ...props }: IconProps) => (
    <svg
      width="20"
      height="20"
      fill={fill}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity="1">
        <path
          d="M8 10.0002H4V20.0002H8M8 10.0002V20.0002M8 10.0002L13.1956 3.93872C13.6886 3.36355 14.4642 3.11628 15.1992 3.30002L15.2467 3.31191C16.5885 3.64735 17.1929 5.21081 16.4258 6.36159L14 10.0002H18.5604C19.8225 10.0002 20.7691 11.1549 20.5216 12.3925L19.3216 18.3925C19.1346 19.3273 18.3138 20.0002 17.3604 20.0002H8"
          stroke="#3E3E3E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  thumbsDown: ({ fill, ...props }: IconProps) => (
    <svg
      width="20"
      height="20"
      fill={fill}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity="1">
        <path
          d="M8 14H4V4H8M8 14V4M8 14L13.1956 20.0615C13.6886 20.6367 14.4642 20.8839 15.1992 20.7002L15.2467 20.6883C16.5885 20.3529 17.1929 18.7894 16.4258 17.6386L14 14H18.5604C19.8225 14 20.7691 12.8453 20.5216 11.6078L19.3216 5.60777C19.1346 4.67292 18.3138 4 17.3604 4H8"
          stroke="#3E3E3E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  help: (props: LucideProps) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.75 13.99C9.75 13.5758 9.41421 13.24 9 13.24C8.58579 13.24 8.25 13.5758 8.25 13.99H9.75ZM8.25 14C8.25 14.4142 8.58579 14.75 9 14.75C9.41421 14.75 9.75 14.4142 9.75 14H8.25ZM8.25 11C8.25 11.4142 8.58579 11.75 9 11.75C9.41421 11.75 9.75 11.4142 9.75 11H8.25ZM5.27587 5.98654C5.16802 6.38647 5.40479 6.7981 5.80472 6.90595C6.20465 7.0138 6.61628 6.77702 6.72413 6.3771L5.27587 5.98654ZM8.25 13.99V14H9.75V13.99H8.25ZM11.25 6.90909C11.25 7.50706 10.8779 7.82322 10.0775 8.36897C9.40123 8.83005 8.25 9.54193 8.25 11H9.75C9.75 10.4581 10.0988 10.1699 10.9225 9.60831C11.6221 9.13133 12.75 8.40203 12.75 6.90909H11.25ZM9 4.75C10.2867 4.75 11.25 5.73398 11.25 6.90909H12.75C12.75 4.87091 11.0801 3.25 9 3.25V4.75ZM6.72413 6.3771C6.96738 5.47508 7.89173 4.75 9 4.75V3.25C7.26777 3.25 5.70934 4.37913 5.27587 5.98654L6.72413 6.3771ZM5 1.75H13V0.25H5V1.75ZM16.25 5V13H17.75V5H16.25ZM13 16.25H5V17.75H13V16.25ZM1.75 13V5H0.25V13H1.75ZM5 16.25C3.20507 16.25 1.75 14.7949 1.75 13H0.25C0.25 15.6234 2.37665 17.75 5 17.75V16.25ZM16.25 13C16.25 14.7949 14.7949 16.25 13 16.25V17.75C15.6234 17.75 17.75 15.6234 17.75 13H16.25ZM13 1.75C14.7949 1.75 16.25 3.20507 16.25 5H17.75C17.75 2.37665 15.6234 0.25 13 0.25V1.75ZM5 0.25C2.37665 0.25 0.25 2.37665 0.25 5H1.75C1.75 3.20507 3.20507 1.75 5 1.75V0.25Z"
        fill="#787878"
      />
    </svg>
  ),
  wallet: (props: LucideProps) => (
    <svg
      width="18"
      height="13"
      viewBox="0 0 18 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.8333 6.59767V6.60683M2.58333 12.0977H15.4167C16.4292 12.0977 17.25 11.2768 17.25 10.2643V2.93099C17.25 1.91847 16.4292 1.09766 15.4167 1.09766H2.58333C1.57081 1.09766 0.75 1.91847 0.75 2.93099V10.2643C0.75 11.2768 1.57081 12.0977 2.58333 12.0977ZM17.25 3.84766H10.8333C9.31455 3.84766 8.08333 5.07887 8.08333 6.59766C8.08333 8.11644 9.31455 9.34766 10.8333 9.34766H17.25V3.84766Z"
        strokeWidth="1.375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  GitHub: (props: LucideProps) => (
    <svg viewBox="0 0 438.549 438.549" {...props}>
      <path
        fill="currentColor"
        d="M409.132 114.573c-19.608-33.596-46.205-60.194-79.798-79.8-33.598-19.607-70.277-29.408-110.063-29.408-39.781 0-76.472 9.804-110.063 29.408-33.596 19.605-60.192 46.204-79.8 79.8C9.803 148.168 0 184.854 0 224.63c0 47.78 13.94 90.745 41.827 128.906 27.884 38.164 63.906 64.572 108.063 79.227 5.14.954 8.945.283 11.419-1.996 2.475-2.282 3.711-5.14 3.711-8.562 0-.571-.049-5.708-.144-15.417a2549.81 2549.81 0 01-.144-25.406l-6.567 1.136c-4.187.767-9.469 1.092-15.846 1-6.374-.089-12.991-.757-19.842-1.999-6.854-1.231-13.229-4.086-19.13-8.559-5.898-4.473-10.085-10.328-12.56-17.556l-2.855-6.57c-1.903-4.374-4.899-9.233-8.992-14.559-4.093-5.331-8.232-8.945-12.419-10.848l-1.999-1.431c-1.332-.951-2.568-2.098-3.711-3.429-1.142-1.331-1.997-2.663-2.568-3.997-.572-1.335-.098-2.43 1.427-3.289 1.525-.859 4.281-1.276 8.28-1.276l5.708.853c3.807.763 8.516 3.042 14.133 6.851 5.614 3.806 10.229 8.754 13.846 14.842 4.38 7.806 9.657 13.754 15.846 17.847 6.184 4.093 12.419 6.136 18.699 6.136 6.28 0 11.704-.476 16.274-1.423 4.565-.952 8.848-2.383 12.847-4.285 1.713-12.758 6.377-22.559 13.988-29.41-10.848-1.14-20.601-2.857-29.264-5.14-8.658-2.286-17.605-5.996-26.835-11.14-9.235-5.137-16.896-11.516-22.985-19.126-6.09-7.614-11.088-17.61-14.987-29.979-3.901-12.374-5.852-26.648-5.852-42.826 0-23.035 7.52-42.637 22.557-58.817-7.044-17.318-6.379-36.732 1.997-58.24 5.52-1.715 13.706-.428 24.554 3.853 10.85 4.283 18.794 7.952 23.84 10.994 5.046 3.041 9.089 5.618 12.135 7.708 17.705-4.947 35.976-7.421 54.818-7.421s37.117 2.474 54.823 7.421l10.849-6.849c7.419-4.57 16.18-8.758 26.262-12.565 10.088-3.805 17.802-4.853 23.134-3.138 8.562 21.509 9.325 40.922 2.279 58.24 15.036 16.18 22.559 35.787 22.559 58.817 0 16.178-1.958 30.497-5.853 42.966-3.9 12.471-8.941 22.457-15.125 29.979-6.191 7.521-13.901 13.85-23.131 18.986-9.232 5.14-18.182 8.85-26.84 11.136-8.662 2.286-18.415 4.004-29.263 5.146 9.894 8.562 14.842 22.077 14.842 40.539v60.237c0 3.422 1.19 6.279 3.572 8.562 2.379 2.279 6.136 2.95 11.276 1.995 44.163-14.653 80.185-41.062 108.068-79.226 27.88-38.161 41.825-81.126 41.825-128.906-.01-39.771-9.818-76.454-29.414-110.049z"
      ></path>
    </svg>
  ),
  X: (props: LucideProps) => (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"
      />
    </svg>
  ),
  Discord: (props: LucideProps) => (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z"
      />
    </svg>
  ),
  google: (props: LucideProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" />
    </svg>
  ),
  Apple: (props: LucideProps) => (
    <svg viewBox="0 0 32 31" {...props}>
      <path
        d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"
        fill="currentColor"
      />
    </svg>
  ),
  Dollar: (props: LucideProps) => (
    <svg viewBox="0 0 44 44" {...props}>
      <path
        d="M22 30.6667H24.1667C25.6111 30.6667 28.5 29.8 28.5 26.3333C28.5 22.8667 25.6111 22 24.1667 22H19.8333C18.3889 22 15.5 21.1333 15.5 17.6667C15.5 14.2 18.3889 13.3333 19.8333 13.3333H22M22 30.6667H15.5M22 30.6667V35M28.5 13.3333H22M22 13.3333V9M41.5 22C41.5 32.7696 32.7696 41.5 22 41.5C11.2304 41.5 2.5 32.7696 2.5 22C2.5 11.2304 11.2304 2.5 22 2.5C32.7696 2.5 41.5 11.2304 41.5 22Z"
        stroke="currentColor"
        strokeWidth="3.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Eye: (props: LucideProps) => (
    <svg viewBox="0 0 45 32" {...props}>
      <path
        d="M22.5002 1.70825C9.50774 1.70825 2.0835 15.9999 2.0835 15.9999C2.0835 15.9999 9.50774 30.2916 22.5002 30.2916C35.4926 30.2916 42.9168 15.9999 42.9168 15.9999C42.9168 15.9999 35.4926 1.70825 22.5002 1.70825Z"
        stroke="currentColor"
        strokeWidth="3.0625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5002 22.1249C25.8829 22.1249 28.6252 19.3827 28.6252 15.9999C28.6252 12.6172 25.8829 9.87492 22.5002 9.87492C19.1174 9.87492 16.3752 12.6172 16.3752 15.9999C16.3752 19.3827 19.1174 22.1249 22.5002 22.1249Z"
        stroke="currentColor"
        strokeWidth="3.0625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Recording: (props: LucideProps) => (
    <svg viewBox="0 0 50 49" {...props}>
      <path
        d="M33.1667 18.375L43.375 14.2916V34.7083L33.1667 30.625M8.66667 11.2291L31.125 11.2291C32.2526 11.2291 33.1667 12.1432 33.1667 13.2708V35.7291C33.1667 36.8567 32.2526 37.7708 31.125 37.7708H8.66667C7.53909 37.7708 6.625 36.8567 6.625 35.7291L6.625 13.2708C6.625 12.1432 7.53909 11.2291 8.66667 11.2291Z"
        stroke="#24BFA3"
        strokeWidth="2.16176"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.956 18.9154V31.5257M13.6509 25.2206H26.2612"
        stroke="currentColor"
        strokeWidth="2.88235"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  TV: (props: LucideProps) => (
    <svg viewBox="0 0 35 33" {...props}>
      <path
        d="M25.3335 12.5626H9.66683M25.3335 12.5626L19.4585 18.4376M25.3335 12.5626L19.4585 6.68758M17.5002 31.1667H25.3335M17.5002 31.1667H9.66683M17.5002 31.1667V23.3334M17.5002 23.3334H3.79183C2.71027 23.3334 1.8335 22.4566 1.8335 21.3751V3.75008C1.8335 2.66852 2.71027 1.79175 3.79183 1.79175H31.2085C32.2901 1.79175 33.1668 2.66852 33.1668 3.75008V21.3751C33.1668 22.4566 32.2901 23.3334 31.2085 23.3334H17.5002Z"
        stroke="currentColor"
        strokeWidth="2.9375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  User: (props: LucideProps) => (
    <svg viewBox="0 0 46 46" {...props}>
      <path
        d="M18.596 30.1875H27.404V27.3125H18.596V30.1875ZM27.404 30.1875C30.5291 30.1875 33.0625 32.7209 33.0625 35.846H35.9375C35.9375 31.1331 32.1169 27.3125 27.404 27.3125V30.1875ZM18.596 27.3125C13.8831 27.3125 10.0625 31.1331 10.0625 35.846H12.9375C12.9375 32.7209 15.4709 30.1875 18.596 30.1875V27.3125ZM27.3125 17.25C27.3125 19.6317 25.3817 21.5625 23 21.5625V24.4375C26.9695 24.4375 30.1875 21.2195 30.1875 17.25H27.3125ZM23 21.5625C20.6183 21.5625 18.6875 19.6317 18.6875 17.25H15.8125C15.8125 21.2195 19.0305 24.4375 23 24.4375V21.5625ZM18.6875 17.25C18.6875 14.8683 20.6183 12.9375 23 12.9375V10.0625C19.0305 10.0625 15.8125 13.2805 15.8125 17.25H18.6875ZM23 12.9375C25.3817 12.9375 27.3125 14.8683 27.3125 17.25H30.1875C30.1875 13.2805 26.9695 10.0625 23 10.0625V12.9375ZM38.8125 23C38.8125 31.733 31.733 38.8125 23 38.8125V41.6875C33.3208 41.6875 41.6875 33.3208 41.6875 23H38.8125ZM23 38.8125C14.267 38.8125 7.1875 31.733 7.1875 23H4.3125C4.3125 33.3208 12.6792 41.6875 23 41.6875V38.8125ZM7.1875 23C7.1875 14.267 14.267 7.1875 23 7.1875V4.3125C12.6792 4.3125 4.3125 12.6792 4.3125 23H7.1875ZM23 7.1875C31.733 7.1875 38.8125 14.267 38.8125 23H41.6875C41.6875 12.6792 33.3208 4.3125 23 4.3125V7.1875Z"
        fill="currentColor"
      />
    </svg>
  ),
  Wallet: (props: LucideProps) => (
    <svg viewBox="0 0 45 45" fill="none" {...props}>
      <path
        d="M40.4068 16.5357H26.627C23.5829 16.5357 21.1151 19.0035 21.1151 22.0476C21.1151 25.0918 23.5829 27.5595 26.627 27.5595H40.4068M26.627 22.0476V22.066M9.37679 9.18652H36.528C38.6702 9.18652 40.4068 11.1059 40.4068 13.4736V30.6217C40.4068 32.9894 38.6702 34.9087 36.528 34.9087H9.37679C7.23462 34.9087 5.49805 32.9894 5.49805 30.6217V13.4736C5.49805 11.1059 7.23462 9.18652 9.37679 9.18652Z"
        stroke="currentColor"
        strokeWidth="2.75595"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  VerticalDot: (props: LucideProps) => (
    <svg viewBox="0 0 21 21" fill="none" {...props}>
      <path
        d="M11.375 4.375C11.375 3.89175 10.9832 3.5 10.5 3.5C10.0168 3.5 9.625 3.89175 9.625 4.375C9.625 4.85825 10.0168 5.25 10.5 5.25C10.9832 5.25 11.375 4.85825 11.375 4.375Z"
        stroke="currentColor"
        strokeWidth="1.3125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.375 10.5C11.375 10.0168 10.9832 9.625 10.5 9.625C10.0168 9.625 9.625 10.0168 9.625 10.5C9.625 10.9832 10.0168 11.375 10.5 11.375C10.9832 11.375 11.375 10.9832 11.375 10.5Z"
        stroke="currentColor"
        strokeWidth="1.3125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.375 16.625C11.375 16.1418 10.9832 15.75 10.5 15.75C10.0168 15.75 9.625 16.1418 9.625 16.625C9.625 17.1082 10.0168 17.5 10.5 17.5C10.9832 17.5 11.375 17.1082 11.375 16.625Z"
        stroke="currentColor"
        strokeWidth="1.3125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Email: (props: LucideProps) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M3.5 5.5L10.5858 12.5858C11.3668 13.3668 12.6332 13.3668 13.4142 12.5858L20.5 5.5M4 19H20C20.5523 19 21 18.5523 21 18V6C21 5.44772 20.5523 5 20 5H4C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Play: (props: LucideProps) => (
    <svg viewBox="0 0 80 80" fill="none" {...props}>
      <path
        d="M27.0815 20.5112V59.9362L59.9357 40.2237L27.0815 20.5112Z"
        stroke="currentColor"
        strokeWidth="4.92812"
        strokeLinejoin="round"
      />
    </svg>
  ),
  EyeOpen: (props: LucideProps) => (
    <svg viewBox="0 0 25 25" fill="none" {...props}>
      <g clipPath="url(#clip0_1644_4871)">
        <path
          d="M11.2682 6.66607C5.70458 7.48891 3.43052 14.079 3.43052 14.079C3.43052 14.079 7.51483 19.7288 13.0784 18.9059C18.642 18.0831 20.9161 11.493 20.9161 11.493C20.9161 11.493 16.8317 5.84323 11.2682 6.66607Z"
          stroke="currentColor"
          strokeWidth="1.32568"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5612 15.4088C14.0098 15.1946 15.0104 13.8466 14.7961 12.3981C14.5819 10.9495 13.2339 9.94894 11.7854 10.1632C10.3368 10.3774 9.33622 11.7254 9.55046 13.1739C9.7647 14.6225 11.1127 15.6231 12.5612 15.4088Z"
          stroke="currentColor"
          strokeWidth="1.32568"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1644_4871">
          <rect
            width="21.2109"
            height="21.2109"
            fill="white"
            transform="translate(0.130371 3.84631) rotate(-8.41294)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  Camera: (props: LucideProps) => (
    <svg viewBox="0 0 67 67" fill="none" {...props}>
      <path
        d="M44.6667 25.1251L58.625 19.5417V47.4584L44.6667 41.8751M11.1667 15.3542H41.875C43.4168 15.3542 44.6667 16.6041 44.6667 18.1459V48.8543C44.6667 50.396 43.4168 51.6459 41.875 51.6459H11.1667C9.62487 51.6459 8.375 50.396 8.375 48.8543V18.1459C8.375 16.6041 9.62487 15.3542 11.1667 15.3542Z"
        stroke="currentColor"
        strokeWidth="3.52632"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Users: (props: LucideProps) => (
    <svg viewBox="0 0 55 36" fill="none" {...props}>
      <path
        d="M41.0653 33.6564V31.375C41.0653 26.3352 36.9796 22.2495 31.9397 22.2495H22.8142C17.7743 22.2495 13.6887 26.3352 13.6887 31.375V33.6564M52.4722 33.6564V31.375C52.4722 26.3352 48.3866 22.2495 43.3467 22.2495H42.206M2.28174 33.6564V31.375C2.28174 26.3352 6.36738 22.2495 11.4073 22.2495H12.548M38.7839 15.4054C42.5638 15.4054 45.6281 12.3411 45.6281 8.5612C45.6281 4.78127 42.5638 1.71704 38.7839 1.71704M15.9701 15.4054C12.1901 15.4054 9.12589 12.3411 9.12589 8.5612C9.12589 4.78127 12.1901 1.71704 15.9701 1.71704M34.2211 8.5612C34.2211 12.3411 31.1569 15.4054 27.377 15.4054C23.5971 15.4054 20.5328 12.3411 20.5328 8.5612C20.5328 4.78127 23.5971 1.71704 27.377 1.71704C31.1569 1.71704 34.2211 4.78127 34.2211 8.5612Z"
        stroke="currentColor"
        strokeWidth="3.42208"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  HamburgerMenu: (props: LucideProps) => (
    <svg viewBox="0 0 30 30" fill="none" {...props}>
      <path
        d="M5 21.25H25M5 15H25M5 8.75H25"
        stroke="currentColor"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Microphone: (props: LucideProps) => (
    <svg viewBox="0 0 35 36" fill="none" {...props}>
      <path
        d="M21.7585 9.42612C21.7585 7.04282 19.8265 5.11078 17.4432 5.11078C15.0599 5.11078 13.1278 7.04282 13.1278 9.42612V18.0568C13.1278 20.4401 15.0599 22.3721 17.4432 22.3721C19.8265 22.3721 21.7585 20.4401 21.7585 18.0568V13.7415M26.0739 18.0568C26.0739 22.8234 22.2098 26.6875 17.4432 26.6875V31.0028M12.6707 25.249C10.3452 23.7028 8.8125 21.0588 8.8125 18.0568M17.4432 31.0028H21.7585M17.4432 31.0028H13.1278"
        stroke="#7A7A7A"
        strokeWidth="2.15767"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Search: (props: LucideProps) => (
    <svg viewBox="0 0 23 23" fill="none" {...props}>
      <path
        d="M18.4267 19.4304C18.7039 19.7076 19.1533 19.7076 19.4305 19.4304C19.7077 19.1532 19.7077 18.7038 19.4305 18.4266L18.4267 19.4304ZM15.3795 9.46426C15.3795 12.7311 12.7312 15.3794 9.46434 15.3794V16.7991C13.5152 16.7991 16.7991 13.5152 16.7991 9.46426H15.3795ZM9.46434 15.3794C6.19748 15.3794 3.54917 12.7311 3.54917 9.46426H2.12954C2.12954 13.5152 5.41344 16.7991 9.46434 16.7991V15.3794ZM3.54917 9.46426C3.54917 6.19741 6.19748 3.5491 9.46434 3.5491V2.12946C5.41344 2.12946 2.12954 5.41336 2.12954 9.46426H3.54917ZM9.46434 3.5491C12.7312 3.5491 15.3795 6.19741 15.3795 9.46426H16.7991C16.7991 5.41336 13.5152 2.12946 9.46434 2.12946V3.5491ZM19.4305 18.4266L14.6984 13.6945L13.6945 14.6983L18.4267 19.4304L19.4305 18.4266Z"
        fill="currentColor"
      />
    </svg>
  ),
  CamPlus: (props: LucideProps) => (
    <svg viewBox="0 0 34 34" fill="none" {...props}>
      <path
        d="M13.5 13.125V21.875M9.125 17.5H17.875"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.6667 12.75L29.75 9.91667V24.0833L22.6667 21.25M5.66667 7.79167H21.25C22.0324 7.79167 22.6667 8.42594 22.6667 9.20834V24.7917C22.6667 25.5741 22.0324 26.2083 21.25 26.2083H5.66667C4.88426 26.2083 4.25 25.5741 4.25 24.7917V9.20834C4.25 8.42593 4.88426 7.79167 5.66667 7.79167Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  ChevronUp: (props: LucideProps) => (
    <svg viewBox="0 0 34 34" fill="none" {...props}>
      <path
        d="M24.0835 19.8335L17.0002 12.7502L9.91683 19.8335"
        stroke="#474747"
        strokeWidth="2.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  ChevronDown: (props: LucideProps) => (
    <svg viewBox="0 0 34 34" fill="none" {...props}>
      <path
        d="M9.9165 14.1665L16.9998 21.2498L24.0832 14.1665"
        stroke="#474747"
        strokeWidth="2.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Home: (props: LucideProps) => (
    <svg viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M3.3335 8.33333L10.0002 2.5L16.6668 8.33333L16.6668 16.6667H12.5002V13.3333C12.5002 12.6703 12.2368 12.0344 11.7679 11.5656C11.2991 11.0967 10.6632 10.8333 10.0002 10.8333C9.33713 10.8333 8.70124 11.0967 8.2324 11.5656C7.76356 12.0344 7.50017 12.6703 7.50017 13.3333V16.6667H3.3335L3.3335 8.33333Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  UserCheck: (props: LucideProps) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M23 9L19.8001 12.1999L18 10.4M8 15H16C18.2091 15 20 16.7909 20 19V21H4V19C4 16.7909 5.79086 15 8 15ZM16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Watchlist: (props: LucideProps) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M6 6C6 4.89543 6.89543 4 8 4H16C17.1046 4 18 4.89543 18 6V21L12 15L6 21V6Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Creator: (props: LucideProps) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M3.5 3.5H10.5V10.5H3.5V3.5Z"
        stroke="currentColor"
        stroke-width="1.375"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.5 13.5H10.5V20.5H3.5V13.5Z"
        stroke="currentColor"
        stroke-width="1.375"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.5 3.5H20.5V10.5H13.5V3.5Z"
        stroke="currentColor"
        stroke-width="1.375"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.5 13.5H20.5V20.5H13.5V13.5Z"
        stroke="currentColor"
        stroke-width="1.375"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  Premium: (props: LucideProps) => (
    // <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-star"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" /></svg>
    <svg width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_117_722" style={{maskType: "alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48">
<rect width="48" height="48" fill="currentColor"/>
</mask>
<g mask="url(#mask0_117_722)">
<path d="M29.9999 42H41.9999V40.35C41.1666 39.5833 40.2332 39 39.1999 38.6C38.1666 38.2 37.0999 38 35.9999 38C34.8999 38 33.8332 38.2 32.7999 38.6C31.7666 39 30.8332 39.5833 29.9999 40.35V42ZM35.9999 36C36.8332 36 37.5416 35.7083 38.1249 35.125C38.7082 34.5417 38.9999 33.8333 38.9999 33C38.9999 32.1667 38.7082 31.4583 38.1249 30.875C37.5416 30.2917 36.8332 30 35.9999 30C35.1666 30 34.4582 30.2917 33.8749 30.875C33.2916 31.4583 32.9999 32.1667 32.9999 33C32.9999 33.8333 33.2916 34.5417 33.8749 35.125C34.4582 35.7083 35.1666 36 35.9999 36ZM24.0999 17C22.1666 17 20.5166 17.6833 19.1499 19.05C17.7832 20.4167 17.0999 22.0667 17.0999 24C17.0999 25.6 17.5499 27 18.4499 28.2C19.3499 29.4 20.5332 30.2333 21.9999 30.7C21.9999 29.9333 22.0082 29.2 22.0249 28.5C22.0416 27.8 22.1832 27.1667 22.4499 26.6C21.9832 26.3333 21.6416 25.9667 21.4249 25.5C21.2082 25.0333 21.0999 24.5333 21.0999 24C21.0999 23.1667 21.3916 22.4583 21.9749 21.875C22.5582 21.2917 23.2666 21 24.0999 21C24.5999 21 25.0749 21.125 25.5249 21.375C25.9749 21.625 26.3499 21.9667 26.6499 22.4C27.0166 22.2333 27.3999 22.1167 27.7999 22.05C28.1999 21.9833 28.5999 21.95 28.9999 21.95H30.7999C30.3666 20.5167 29.5416 19.3333 28.3249 18.4C27.1082 17.4667 25.6999 17 24.0999 17ZM18.4999 44L17.6999 37.6C17.2666 37.4333 16.8582 37.2333 16.4749 37C16.0916 36.7667 15.7166 36.5167 15.3499 36.25L9.3999 38.75L3.8999 29.25L9.0499 25.35C9.01657 25.1167 8.9999 24.8917 8.9999 24.675V23.325C8.9999 23.1083 9.01657 22.8833 9.0499 22.65L3.8999 18.75L9.3999 9.25L15.3499 11.75C15.7166 11.4833 16.0999 11.2333 16.4999 11C16.8999 10.7667 17.2999 10.5667 17.6999 10.4L18.4999 4H29.4999L30.2999 10.4C30.7332 10.5667 31.1416 10.7667 31.5249 11C31.9082 11.2333 32.2832 11.4833 32.6499 11.75L38.5999 9.25L44.0999 18.75L39.8499 22H34.7999C34.7666 21.8333 34.7332 21.6583 34.6999 21.475C34.6666 21.2917 34.6166 21.1167 34.5499 20.95L38.8499 17.7L36.8999 14.3L31.9499 16.4C31.2166 15.6333 30.4082 14.9917 29.5249 14.475C28.6416 13.9583 27.6832 13.5667 26.6499 13.3L25.9999 8H22.0499L21.3499 13.3C20.3166 13.5667 19.3582 13.9583 18.4749 14.475C17.5916 14.9917 16.7832 15.6167 16.0499 16.35L11.0999 14.3L9.1499 17.7L13.4499 20.9C13.2832 21.4 13.1666 21.9 13.0999 22.4C13.0332 22.9 12.9999 23.4333 12.9999 24C12.9999 24.5333 13.0332 25.05 13.0999 25.55C13.1666 26.05 13.2832 26.55 13.4499 27.05L9.1499 30.3L11.0999 33.7L16.0499 31.6C16.8499 32.4333 17.7499 33.1333 18.7499 33.7C19.7499 34.2667 20.8332 34.6333 21.9999 34.8V44H18.4999ZM28.9999 46C28.1666 46 27.4582 45.7083 26.8749 45.125C26.2916 44.5417 25.9999 43.8333 25.9999 43V29C25.9999 28.1667 26.2916 27.4583 26.8749 26.875C27.4582 26.2917 28.1666 26 28.9999 26H42.9999C43.8332 26 44.5416 26.2917 45.1249 26.875C45.7082 27.4583 45.9999 28.1667 45.9999 29V43C45.9999 43.8333 45.7082 44.5417 45.1249 45.125C44.5416 45.7083 43.8332 46 42.9999 46H28.9999Z" fill="#9F9F9F"/>
</g>
</svg>
  ),
  Rentals: (props: LucideProps) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M6 9.5V14.5M18 9.5V14.5M3.11111 6H20.8889C21.5025 6 22 6.53726 22 7.2V16.8C22 17.4627 21.5025 18 20.8889 18H3.11111C2.49746 18 2 17.4627 2 16.8V7.2C2 6.53726 2.49746 6 3.11111 6ZM14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Write: (props: LucideProps) => (
    <svg viewBox="0 0 17 17" fill="none" {...props}>
      <path
        d="M12.7502 7.08333L14.8752 4.95833L12.0418 2.125L9.91683 4.25M12.7502 7.08333L5.66683 14.1667H2.8335V11.3333L9.91683 4.25M12.7502 7.08333L9.91683 4.25"
        stroke="currentColor"
        strokeWidth="1.0625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  CheckmarkCircle: (props: LucideProps) => (
    <svg viewBox="0 0 54 54" fill="none" {...props}>
      <path
        d="M42.2084 20.2084C43.0139 19.403 43.0139 18.097 42.2084 17.2916C41.403 16.4861 40.097 16.4861 39.2916 17.2916L42.2084 20.2084ZM21.4999 38.0001L20.0415 39.4585C20.847 40.2639 22.1529 40.2639 22.9584 39.4585L21.4999 38.0001ZM14.7082 28.2916C13.9028 27.4861 12.5969 27.4861 11.7914 28.2916C10.986 29.0971 10.986 30.403 11.7914 31.2084L14.7082 28.2916ZM39.2916 17.2916L20.0415 36.5416L22.9584 39.4585L42.2084 20.2084L39.2916 17.2916ZM11.7914 31.2084L20.0415 39.4585L22.9583 36.5416L14.7082 28.2916L11.7914 31.2084ZM49.6875 27C49.6875 39.53 39.53 49.6875 27 49.6875V53.8125C41.8081 53.8125 53.8125 41.8081 53.8125 27H49.6875ZM27 49.6875C14.47 49.6875 4.3125 39.53 4.3125 27H0.1875C0.1875 41.8081 12.1919 53.8125 27 53.8125V49.6875ZM4.3125 27C4.3125 14.47 14.47 4.3125 27 4.3125V0.1875C12.1919 0.1875 0.1875 12.1919 0.1875 27H4.3125ZM27 4.3125C39.53 4.3125 49.6875 14.47 49.6875 27H53.8125C53.8125 12.1919 41.8081 0.1875 27 0.1875V4.3125Z"
        fill="currentColor"
      />
    </svg>
  ),
  FancyArrow: (props: LucideProps) => (
    <svg viewBox="0 0 131 131" fill="none" {...props}>
      <g clip-path="url(#clip0_1489_3930)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M77.2498 74.8193C78.1694 74.9454 79.0937 75.0636 79.8777 75.1188C93.855 76.1756 109.184 73.5139 121.384 66.5996C121.824 66.3453 122.005 65.7939 121.751 65.3476C121.498 64.9012 120.953 64.7583 120.512 65.0134C108.55 71.7041 93.6324 74.2959 80.0041 73.2626C79.5655 73.2367 79.0585 73.1759 78.5499 73.1177C79.1075 72.131 79.301 71.1437 79.2681 70.2234C79.1797 68.833 78.5134 67.4901 77.4713 66.3029C76.0079 64.6474 73.8731 63.3206 71.673 62.5085C69.9761 61.9015 68.2406 61.63 66.921 61.8352C65.8241 61.9789 64.9789 62.4331 64.4267 63.1345C63.8486 63.8753 63.595 64.9534 63.9755 66.4539C64.5704 69.0148 66.4385 70.8871 68.9192 72.2427C70.731 73.2296 72.8396 73.9031 74.9006 74.3722C74.37 74.7634 73.7485 75.154 73.0346 75.5468C67.5165 78.396 58.6072 78.6413 49.0951 77.446C34.6249 75.6141 18.7453 70.3806 11.2129 65.4809C10.8298 65.2318 10.2187 65.3295 9.93759 65.7571C9.65649 66.1847 9.81128 66.7813 10.1943 67.0304C17.9181 72.0549 34.082 77.4098 48.8804 79.297C58.8173 80.5392 68.1587 80.1924 73.8777 77.1764C75.2963 76.4048 76.4394 75.6362 77.2498 74.8193ZM76.558 72.8216C77.1943 71.9923 77.4649 71.1651 77.4479 70.3592C77.3801 69.3532 76.8323 68.3844 76.1075 67.5461C74.8564 66.1222 72.9703 64.9707 71.0632 64.2675C69.7367 63.79 68.3665 63.5181 67.2914 63.6288C66.6975 63.7004 66.2121 63.8835 65.8824 64.2463C65.6109 64.6593 65.5898 65.2469 65.7323 66.0004C66.2705 68.0929 67.8605 69.5555 69.8071 70.6146C71.8214 71.7092 74.3488 72.4393 76.558 72.8216Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M120.481 65.0987C116.142 68.2329 112.6 72.9283 110.265 77.7272C110.05 78.1935 110.233 78.746 110.65 78.9435C111.13 79.1835 111.703 79.0054 111.918 78.5398C114.156 74.0264 117.458 69.5581 121.582 66.6124C121.972 66.2964 122.075 65.7229 121.794 65.3192C121.448 64.8743 120.871 64.7827 120.481 65.0987Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M120.65 64.8916C115.744 66.3941 110.211 64.6899 105.735 62.4889C105.318 62.2914 104.744 62.4704 104.529 62.9366C104.314 63.4022 104.498 63.9544 104.979 64.1937C109.805 66.5568 115.855 68.3035 121.213 66.6686C121.685 66.5051 121.942 65.9751 121.802 65.4948C121.663 65.014 121.122 64.7287 120.65 64.8916Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1489_3930">
          <rect
            width="93.83"
            height="93.83"
            fill="white"
            transform="translate(79.3633 130.922) rotate(-146.68)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  WarningTriangle: (props: LucideProps) => (
    <svg viewBox="0 0 176 157" fill="none" {...props}>
      <path
        d="M173.001 128.946L104.68 10.2974C102.973 7.39055 100.536 4.98035 97.61 3.30567C94.6842 1.631 91.3717 0.75 88.0005 0.75C84.6294 0.75 81.3168 1.631 78.3911 3.30567C75.4654 4.98035 73.0281 7.39055 71.3209 10.2974L3.00057 128.946C1.35788 131.757 0.492188 134.955 0.492188 138.211C0.492188 141.468 1.35788 144.665 3.00057 147.477C4.68596 150.401 7.11908 152.825 10.0503 154.498C12.9814 156.172 16.3051 157.036 19.6802 157.001H156.321C159.693 157.033 163.014 156.168 165.942 154.494C168.87 152.821 171.301 150.399 172.985 147.477C174.63 144.667 175.498 141.47 175.501 138.214C175.504 134.957 174.641 131.759 173.001 128.946ZM162.165 141.219C161.569 142.235 160.714 143.075 159.687 143.651C158.66 144.228 157.498 144.521 156.321 144.501H19.6802C18.5027 144.521 17.341 144.228 16.3141 143.651C15.2872 143.075 14.4321 142.235 13.8365 141.219C13.297 140.306 13.0124 139.264 13.0124 138.204C13.0124 137.143 13.297 136.101 13.8365 135.188L82.1568 16.5396C82.7644 15.5284 83.6234 14.6917 84.6501 14.1108C85.6769 13.53 86.8365 13.2247 88.0162 13.2247C89.1958 13.2247 90.3554 13.53 91.3822 14.1108C92.409 14.6917 93.2679 15.5284 93.8755 16.5396L162.196 135.188C162.731 136.104 163.01 137.147 163.004 138.208C162.999 139.269 162.709 140.309 162.165 141.219ZM81.7505 94.5005V63.2505C81.7505 61.5929 82.409 60.0032 83.5811 58.8311C84.7532 57.659 86.3429 57.0005 88.0005 57.0005C89.6581 57.0005 91.2479 57.659 92.42 58.8311C93.5921 60.0032 94.2505 61.5929 94.2505 63.2505V94.5005C94.2505 96.1581 93.5921 97.7478 92.42 98.9199C91.2479 100.092 89.6581 100.751 88.0005 100.751C86.3429 100.751 84.7532 100.092 83.5811 98.9199C82.409 97.7478 81.7505 96.1581 81.7505 94.5005ZM97.3755 122.626C97.3755 124.48 96.8257 126.292 95.7956 127.834C94.7654 129.376 93.3012 130.577 91.5882 131.287C89.8751 131.996 87.9901 132.182 86.1716 131.82C84.353 131.459 82.6825 130.566 81.3714 129.255C80.0603 127.944 79.1674 126.273 78.8057 124.454C78.4439 122.636 78.6296 120.751 79.3392 119.038C80.0487 117.325 81.2504 115.861 82.7921 114.83C84.3338 113.8 86.1463 113.251 88.0005 113.251C90.4869 113.251 92.8715 114.238 94.6297 115.996C96.3878 117.755 97.3755 120.139 97.3755 122.626Z"
        fill="#E9E9E9"
      />
    </svg>
  ),
  LightningWhite: (props: LucideProps) => (
    <svg width="24" height="23" viewBox="0 0 24 23" fill="none" {...props}>
      <path d="M4.49929 13.3774C4.32188 13.378 4.14794 13.3283 3.99768 13.234C3.84742 13.1397 3.72701 13.0046 3.65043 12.8446C3.57385 12.6846 3.54425 12.5061 3.56507 12.3299C3.58589 12.1538 3.65627 11.9871 3.76804 11.8493L13.0493 2.28682C13.1189 2.20646 13.2138 2.15215 13.3183 2.13282C13.4229 2.11348 13.5309 2.13027 13.6247 2.18041C13.7184 2.23056 13.7923 2.31109 13.8343 2.40879C13.8762 2.50649 13.8837 2.61555 13.8555 2.71807L12.0555 8.36182C12.0025 8.50387 11.9846 8.65668 12.0036 8.80714C12.0226 8.95759 12.0777 9.1012 12.1644 9.22565C12.251 9.3501 12.3666 9.45167 12.5011 9.52165C12.6356 9.59163 12.7851 9.62793 12.9368 9.62744H19.4993C19.6767 9.62684 19.8506 9.67658 20.0009 9.7709C20.1512 9.86522 20.2716 10.0002 20.3482 10.1603C20.4247 10.3203 20.4543 10.4988 20.4335 10.6749C20.4127 10.8511 20.3423 11.0178 20.2305 11.1556L10.9493 20.7181C10.8797 20.7984 10.7848 20.8527 10.6802 20.8721C10.5757 20.8914 10.4677 20.8746 10.3739 20.8245C10.2802 20.7743 10.2062 20.6938 10.1643 20.5961C10.1223 20.4984 10.1148 20.3893 10.143 20.2868L11.943 14.6431C11.9961 14.501 12.0139 14.3482 11.995 14.1977C11.976 14.0473 11.9209 13.9037 11.8342 13.7792C11.7476 13.6548 11.632 13.5532 11.4975 13.4832C11.3629 13.4132 11.2134 13.3769 11.0618 13.3774H4.49929Z" stroke="white" stroke-width="1.875" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  ),
}